import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbFilledSvg from "@ant-design/icons-svg/es/asn/UsbFilled";
import AntdIcon from '../components/AntdIcon';
var UsbFilled = function UsbFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: UsbFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(UsbFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'UsbFilled';
}
export default RefIcon;